(function () {
  "use strict";


  /* ================================
     SETTINGS
     ================================ */

  const CURRENT_LOCALE = (
    (window.Shopify && window.Shopify.locale) ||
    document.documentElement.lang ||
    "en"
  ).toLowerCase().split("-")[0];

  const STORAGE_KEY =
    `cafe_liegeois_product_compare_v1_${CURRENT_LOCALE}`;

  const MAX_PRODUCTS = 3;


  const translationElement =
    document.querySelector(
      "[data-compare-translations]"
    );

  const compareTranslations =
    translationElement
      ? JSON.parse(translationElement.textContent)
      : {};


  let selectedProducts = [];


  /* ================================
     STORAGE
     ================================ */

  function loadProducts() {

    try {

      const stored =
        localStorage.getItem(
          STORAGE_KEY
        );

      if (stored) {

        selectedProducts =
          JSON.parse(stored);

      }

    } catch (error) {

      selectedProducts = [];

    }

  }


  function saveProducts() {

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(selectedProducts)
    );

  }


  /* ================================
     PRODUCT DATA
     ================================ */

  function getProductFromCheckbox(checkbox) {

    if (!checkbox) return null;


    const wrapper =
      checkbox.closest(
        ".product-compare-wrapper"
      );

    if (!wrapper) return null;


    const dataElement =
      wrapper.nextElementSibling;


    if (
      !dataElement ||
      !dataElement.matches(
        "[data-product-compare-data]"
      )
    ) {

      return null;

    }


    try {

      return JSON.parse(
        dataElement.textContent
      );

    } catch (error) {

      console.error(
        "Erreur avec les données du produit.",
        error
      );

      return null;

    }

  }


  /* ================================
     ADD PRODUCT
     ================================ */

  function addProduct(product) {

    if (!product) return;


    const alreadySelected =
      selectedProducts.some(
        item =>
          String(item.id) ===
          String(product.id)
      );


    if (alreadySelected) {

      updateInterface();

      return;

    }


    if (
      selectedProducts.length >=
      MAX_PRODUCTS
    ) {

      alert(
        compareTranslations.max_products ||
        "You can compare up to 3 products."
      );

      updateCheckbox();

      return;

    }


    const productToSave = {

      ...product,

      wifi_app:
        product.wifi_app ?? "",

      cold_milk_foam:
        product.cold_milk_foam ?? "",

      number_of_drink_recipes:
        product.number_of_drink_recipes ?? "",

      milk_drinks:
        product.milk_drinks ?? "",

      cold_brew:
        product.cold_brew ?? "",

      number_of_profiles:
        product.number_of_profiles ?? "",

      direct_water_supply:
        product.direct_water_supply ?? ""

    };


    selectedProducts.push(
      productToSave
    );


    saveProducts();

    updateInterface();

  }


  /* ================================
     REMOVE PRODUCT
     ================================ */

  function removeProduct(productId) {

    selectedProducts =
      selectedProducts.filter(
        product =>
          String(product.id) !==
          String(productId)
      );


    saveProducts();

    updateInterface();

  }


  /* ================================
     CLEAR
     ================================ */

  function clearProducts() {

    selectedProducts = [];

    saveProducts();

    updateInterface();

  }


  /* ================================
     CHECKBOXES
     ================================ */

  function updateCheckbox() {

    const checkboxes =
      document.querySelectorAll(
        "[data-compare-checkbox]"
      );


    checkboxes.forEach(
      function (checkbox) {

        const product =
          getProductFromCheckbox(
            checkbox
          );


        if (!product) return;


        checkbox.checked =
          selectedProducts.some(
            item =>
              String(item.id) ===
              String(product.id)
          );

      }
    );

  }


  function setupCheckbox() {

    const checkboxes =
      document.querySelectorAll(
        "[data-compare-checkbox]"
      );


    checkboxes.forEach(
      function (checkbox) {

        /*
         * Prevent duplicate event listeners.
         * Useful if Shopify redraws content.
         */

        if (
          checkbox.dataset.compareBound ===
          "true"
        ) {

          return;

        }


        checkbox.dataset.compareBound =
          "true";


        checkbox.addEventListener(
          "change",
          function () {

            const product =
              getProductFromCheckbox(
                this
              );


            if (!product) {

              this.checked = false;

              return;

            }


            if (this.checked) {

              addProduct(product);

            } else {

              removeProduct(
                product.id
              );

            }

          }
        );

      }
    );


    updateCheckbox();

  }


  /* ================================
     FLOATING BAR
     ================================ */

  function updateBar() {

    const bar =
      document.querySelector(
        "#product-compare-bar"
      );


    if (!bar) return;


    const count =
      document.querySelector(
        "[data-compare-count]"
      );


    const items =
      document.querySelector(
        "[data-compare-items]"
      );


    const compareButton =
      document.querySelector(
        "[data-compare-open]"
      );


    if (
      !count ||
      !items
    ) {

      return;

    }


    count.textContent =
      selectedProducts.length;


    items.innerHTML = "";


    selectedProducts.forEach(
      function (product) {

        const item =
          document.createElement(
            "div"
          );


        item.className =
          "product-compare-item";


        const image =
          document.createElement(
            "img"
          );


        if (product.image) {

          image.src =
            normalizeImageUrl(
              product.image
            );

        }


        image.alt =
          product.title || "";


        const name =
          document.createElement(
            "span"
          );


        name.className =
          "product-compare-item__name";


        name.textContent =
          product.title || "";


        const remove =
          document.createElement(
            "button"
          );


        remove.className =
          "product-compare-item__remove";


        remove.type =
          "button";


        remove.setAttribute(
          "aria-label",
          (
            compareTranslations.remove ||
            "Remove"
          ) +
          " " +
          (
            product.title ||
            ""
          )
        );


        remove.textContent =
          "×";


        remove.addEventListener(
          "click",
          function () {

            removeProduct(
              product.id
            );

          }
        );


        item.appendChild(
          image
        );

        item.appendChild(
          name
        );

        item.appendChild(
          remove
        );


        items.appendChild(
          item
        );

      }
    );


    if (
      selectedProducts.length > 0
    ) {

      bar.classList.add(
        "is-visible"
      );

      bar.setAttribute(
        "aria-hidden",
        "false"
      );

    } else {

      bar.classList.remove(
        "is-visible"
      );

      bar.setAttribute(
        "aria-hidden",
        "true"
      );

    }


    if (compareButton) {

      compareButton.disabled =
        selectedProducts.length < 2;

    }

  }


  /* ================================
     MODAL
     ================================ */

  function openModal() {

    if (
      selectedProducts.length < 2
    ) {

      return;

    }


    const modal =
      document.querySelector(
        "#product-compare-modal"
      );


    if (!modal) return;


    buildComparisonTable();


    modal.classList.add(
      "is-open"
    );


    modal.setAttribute(
      "aria-hidden",
      "false"
    );


    document.body.style.overflow =
      "hidden";

  }


  function closeModal() {

    const modal =
      document.querySelector(
        "#product-compare-modal"
      );


    if (!modal) return;


    modal.classList.remove(
      "is-open"
    );


    modal.setAttribute(
      "aria-hidden",
      "true"
    );


    document.body.style.overflow =
      "";

  }


  /* ================================
     COMPARISON FIELDS
     ================================ */

  const fields = [

    {
      key: "machine_type",
      label:
        compareTranslations.machine_type
    },

    {
      key: "grinder",
      label:
        compareTranslations.grinder
    },

    {
      key: "water_tank",
      label:
        compareTranslations.water_tank
    },

    {
      key: "bean_hopper",
      label:
        compareTranslations.bean_hopper
    },

    {
      key: "dimensions",
      label:
        compareTranslations.dimensions
    },

    {
      key: "warranty",
      label:
        compareTranslations.warranty
    },

    {
      key: "wifi_app",
      label:
        compareTranslations.wifi_app
    },

    {
      key: "cold_milk_foam",
      label:
        compareTranslations.cold_milk_foam
    },

    {
      key: "number_of_drink_recipes",
      label:
        compareTranslations.number_of_drink_recipes
    },

    {
      key: "milk_drinks",
      label:
        compareTranslations.milk_drinks
    },

    {
      key: "cold_brew",
      label:
        compareTranslations.cold_brew
    },

    {
      key: "number_of_profiles",
      label:
        compareTranslations.number_of_profiles
    },

    {
      key: "direct_water_supply",
      label:
        compareTranslations.direct_water_supply
    }

  ];


  /* ================================
     TRANSLATE VALUES
     ================================ */

  function translateCompareValue(value) {

    if (!value) return "—";


    const language =
      (
        window.Shopify &&
        window.Shopify.locale
      )
        ? window.Shopify.locale
        : (
          document.documentElement.lang ||
          "en"
        );


    if (
      language
        .toLowerCase()
        .split("-")[0] !==
      "fr"
    ) {

      return value;

    }


    const cleanValue =
      String(value)
        .trim()
        .replace(
          /\uFE0F/g,
          ""
        )
        .replace(
          /\s+/g,
          " "
        );


    const translations = {

      "Yes": "✅",

      "No": "❌",


      "Semi-automatic":
        "Semi-automatique",

      "Manual":
        "Manuelle",

      "Automatic":
        "Automatique",


      "Steel conical burr grinder":
        "Meule conique en acier",

      "Hardened steel grinder":
        "Meule conique en acier inoxydable",

      "Ceramic grinder":
        "Moulin en céramique",


      "❌ (no integrated grinder)":
        "❌ (pas de moulin intégré)",

      "✅ (only cappuccino)":
        "✅ (seulement cappuccino)",

      "✅ (steam wand integrated)":
        "✅ (buse à vapeur intégrée)",


      "1 year":
        "1 an",

      "2 years":
        "2 ans",

      "3 years":
        "3 ans",


      "With the purchase of the Wi-Fi Connect V2":
        "Avec l'achat du Wi-Fi Connect V2",


      "Coffee and milk based drinks possible":
        "Café et boissons à base de lait possibles"

    };


    return (
      translations[cleanValue] ||
      value
    );

  }


  /* ================================
     BUILD TABLE
     ================================ */

  function buildComparisonTable() {

    const table =
      document.querySelector(
        "[data-compare-table]"
      );


    if (!table) return;


    table.innerHTML =
      "";


    /* HEADER */

    const thead =
      document.createElement(
        "thead"
      );


    const headerRow =
      document.createElement(
        "tr"
      );


    const attributeHeader =
      document.createElement(
        "th"
      );


    attributeHeader.textContent =
      compareTranslations.features ||
      "Features";


    attributeHeader.className =
      "product-compare-table__attribute";


    headerRow.appendChild(
      attributeHeader
    );


    selectedProducts.forEach(
      function (product) {

        const th =
          document.createElement(
            "th"
          );


        th.className =
          "product-compare-product";


        const link =
          document.createElement(
            "a"
          );


        link.href =
          product.url || "#";


        if (product.image) {

          const image =
            document.createElement(
              "img"
            );


          image.src =
            normalizeImageUrl(
              product.image
            );


          image.alt =
            product.title || "";


          link.appendChild(
            image
          );

        }


        const name =
          document.createElement(
            "span"
          );


        name.className =
          "product-compare-product__name";


        name.textContent =
          product.title || "";


        link.appendChild(
          name
        );


        const price =
          document.createElement(
            "span"
          );


        price.className =
          "product-compare-product__price";


        price.textContent =
          product.priceFormatted ||
          "";


        link.appendChild(
          price
        );


        th.appendChild(
          link
        );


        headerRow.appendChild(
          th
        );

      }
    );


    thead.appendChild(
      headerRow
    );


    table.appendChild(
      thead
    );


    /* BODY */

    const tbody =
      document.createElement(
        "tbody"
      );


    fields.forEach(
      function (field) {

        const row =
          document.createElement(
            "tr"
          );


        const label =
          document.createElement(
            "td"
          );


        label.className =
          "product-compare-table__attribute";


        label.textContent =
          field.label ||
          field.key;


        row.appendChild(
          label
        );


        selectedProducts.forEach(
          function (product) {

            const cell =
              document.createElement(
                "td"
              );


            let value =
              product[field.key];


            if (
              value === null ||
              value === undefined ||
              value === ""
            ) {

              value = "—";

            }


            cell.textContent =
              translateCompareValue(
                String(value)
              );


            row.appendChild(
              cell
            );

          }
        );


        tbody.appendChild(
          row
        );

      }
    );


    table.appendChild(
      tbody
    );

  }


  /* ================================
     IMAGE URL
     ================================ */

  function normalizeImageUrl(url) {

    if (!url) return "";


    if (
      url.startsWith("//")
    ) {

      return (
        "https:" +
        url
      );

    }


    return url;

  }


  /* ================================
     EVENTS
     ================================ */

  function setupEvents() {

    const openButton =
      document.querySelector(
        "[data-compare-open]"
      );


    if (openButton) {

      openButton.addEventListener(
        "click",
        openModal
      );

    }


    const clearButton =
      document.querySelector(
        "[data-compare-clear]"
      );


    if (clearButton) {

      clearButton.addEventListener(
        "click",
        clearProducts
      );

    }


    const closeButton =
      document.querySelector(
        "[data-compare-close]"
      );


    if (closeButton) {

      closeButton.addEventListener(
        "click",
        closeModal
      );

    }


    const modal =
      document.querySelector(
        "#product-compare-modal"
      );


    if (modal) {

      modal.addEventListener(
        "click",
        function (event) {

          if (
            event.target ===
            modal
          ) {

            closeModal();

          }

        }
      );

    }


    document.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key ===
          "Escape"
        ) {

          closeModal();

        }

      }
    );

  }


  /* ================================
     UPDATE
     ================================ */

  function updateInterface() {

    updateCheckbox();

    updateBar();

  }


  /* ================================
     INIT
     ================================ */

  function init() {

    loadProducts();

    setupCheckbox();

    setupEvents();

    updateInterface();

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {

    init();

  }

})();